import { ContentCopy as CopyIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { Box, Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { useUnit } from 'effector-react';
import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { styled } from '@shared/styles';
import { $userStore } from '@store';
import LazyImage from '../LazyImage/index';
import { createShaHash } from '@magnetmlm/common';
import { useMediaQuery } from 'react-responsive';
import { useRouter } from 'next/router';
import { useReferralLink } from '@entities/user/lib/hooks';

function shortenString(str: string, length?: number, start?: number, end?: number): string {
  if (str.length <= (length || 10)) {
    return str;
  }

  const firstThree = str.slice(0, start || 7);
  const lastThree = str.slice(-(end || 7));

  return `${firstThree}...${lastThree}`;
}

interface IDropDown {
  dropdownAnchorEl: null | Element;
  setIsChangeNameModal: (el: boolean) => void;
  setIsChangeNickNameModal: (el: boolean) => void;
  setIsCMRegistrationInfoOpened: (el: boolean) => void;
  handleCopyRefLink: () => void;
  handleDisconnect: () => void;
  isUserRegistered: boolean;
  className?: string;
  onClose?: () => void;
}

let DropDown: FC<IDropDown> = ({
  dropdownAnchorEl,
  setIsChangeNameModal,
  setIsCMRegistrationInfoOpened,
  handleCopyRefLink,
  handleDisconnect,
  isUserRegistered,
  setIsChangeNickNameModal,
  className,
  onClose
}) => {
  const { user } = useUnit($userStore);
  const t = useTranslations();
  const { push } = useRouter();
  const isMobile = useMediaQuery({ query: '(max-width: 567px)' });
  const referralLink = useReferralLink();

  const openCabinet = () => {
    push('/career');
  };

  return (
    <Box
      className={className}
      sx={{
        opacity: dropdownAnchorEl ? '1' : '0',
        scale: dropdownAnchorEl ? '1' : '0.9',
        visibility: dropdownAnchorEl ? 'visible' : 'hidden',
        pointerEvents: dropdownAnchorEl ? 'auto' : 'none'
      }}
    >
      {isUserRegistered && (
        <>
          <MenuItem className='menu_item_cm user_dropdown_item' onClick={isMobile ? onClose : undefined}>
            <ListItemText>
              <span className='user_dropdown_title'>
                {t('header.dropdown.yourId')} {user?.hashedUid}
                {/*{t('header.dropdown.yourId')} {preRegistrationIds?.userPreRegistrationId}*/}
              </span>{' '}
            </ListItemText>
            {isMobile && (
              <ListItemIcon>
                <LazyImage
                  style={{ width: 38, position: 'relative', left: -5 }}
                  src={'/images/icons/landing/close-dark.svg'}
                  alt='close'
                />
              </ListItemIcon>
            )}
          </MenuItem>
          <Divider style={{ margin: '0px 0' }} />
          <MenuItem className='menu_item_cm user_dropdown_item' onClick={() => setIsChangeNameModal(true)}>
            <ListItemText>
              <span className='user_dropdown_label'>
                {user?.name || user?.lastname ? t('header.dropdown.yourName') : t('header.dropdown.enterName')}
              </span>
              <span className='user_dropdown_title'>
                {user?.name || user?.lastname ? `${user.name} ${user.lastname}` : t('header.dropdown.nameLastname')}
              </span>
            </ListItemText>
            <ListItemIcon>
              <LazyImage src='/images/icons/landing/edit-dark.svg' alt='' />
            </ListItemIcon>
          </MenuItem>{' '}
          <Divider style={{ margin: '0px 0' }} />
          <MenuItem className='menu_item_cm user_dropdown_item' onClick={handleCopyRefLink}>
            <ListItemText>
              <span className='user_dropdown_label'>{t('header.dropdown.ref')}</span>
              <span className='user_dropdown_title'>{shortenString(referralLink, 12, 10, 10)}</span>{' '}
            </ListItemText>
            <ListItemIcon>
              <CopyIcon sx={{ width: 24, height: 24, color: 'black' }} fontSize='small' />
            </ListItemIcon>
          </MenuItem>
          <Divider style={{ margin: '0px 0' }} />
        </>
      )}{' '}
      {/*{!user?.telegramId ? (*/}
      {/*  <>*/}
      {/*    <MenuItem className='menu_item_cm user_dropdown_item' onClick={() => setIsCMRegistrationInfoOpened(true)}>*/}
      {/*      <ListItemText>*/}
      {/*        <span className='user_dropdown_title'>*/}
      {/*          {t('header.dropdown.registerCryptoMagnet_1')} <br />*/}
      {/*          {t('header.dropdown.registerCryptoMagnet_2')}*/}
      {/*        </span>{' '}*/}
      {/*      </ListItemText>*/}
      {/*      <ListItemIcon>*/}
      {/*        <LazyImage style={{ width: 24, height: 24 }} src='/images/icons/landing/link.svg' alt='link' />*/}
      {/*      </ListItemIcon>*/}
      {/*    </MenuItem>*/}
      {/*    <Divider style={{ margin: '0px 0' }} />*/}
      {/*  </>*/}
      {/*) : (*/}
      {/*  <>*/}
      {/*    <MenuItem onClick={() => setIsChangeNickNameModal(true)} className='menu_item_cm user_dropdown_item'>*/}
      {/*      <ListItemText>*/}
      {/*        <span className='user_dropdown_title'>*/}
      {/*          {t('header.dropdown.nickname_1')} <br />*/}
      {/*          {t('header.dropdown.nickname_2')}*/}
      {/*        </span>*/}
      {/*      </ListItemText>*/}
      {/*      <ListItemIcon>*/}
      {/*        <LazyImage style={{ width: 24, height: 24 }} src='/images/icons/landing/link.svg' alt='link' />*/}
      {/*      </ListItemIcon>*/}
      {/*    </MenuItem>*/}
      {/*    <Divider style={{ margin: '0px 0' }} />*/}
      {/*  </>*/}
      {/*)}*/}
      {user?.isRegistrationConfirmed && (
        <>
          <MenuItem className='menu_item_cm user_dropdown_item' onClick={openCabinet}>
            <ListItemText>
              <span className='user_dropdown_title'>{t('header.dropdown.visit')}</span>
            </ListItemText>
            <ListItemIcon>
              <LogoutIcon fontSize='small' style={{ width: 24, height: 24, color: 'black' }} />
            </ListItemIcon>
          </MenuItem>
          <Divider style={{ margin: '0px 0' }} />
        </>
      )}
      <MenuItem className='menu_item_cm user_dropdown_item' onClick={handleDisconnect}>
        <ListItemText>
          <span className='user_dropdown_title'>{t('header.dropdown.disconnect')}</span>
        </ListItemText>
        <ListItemIcon>
          <LogoutIcon fontSize='small' style={{ width: 24, height: 24, color: 'black' }} />
        </ListItemIcon>
      </MenuItem>
    </Box>
  );
};

DropDown = styled(DropDown, {
  '&': {
    position: 'absolute',
    top: '60px',
    borderRadius: '12px',
    right: '0',
    background: 'white',
    width: '100%',
    transition: 'all 0.25s',

    '@media (max-width: 567px)': {
      top: '50%',
      left: '50%',
      right: 'auto',
      transform: 'translate(-50%, -50%)',
      zIndex: 100,
      width: 'calc(100% - 40px)',
      maxWidth: 360
    }
  },
  '& .dropdown_wrapper': {
    position: 'relative'
  },
  '& .dropdown_close': {
    position: 'absolute',
    top: 10,
    right: 10,
    width: '24px !important',
    height: '24px !important',
    borderRadius: 100,
    display: 'none',
    zIndex: 100,
    backgroundColor: 'transparent',

    '@media (max-width: 567px)': {
      display: 'block'
    }
  },
  '& .menu_item_cm': {
    position: 'relative',
    gap: '20px',
    padding: '8px 20px !important',
    '@toXL': {
      padding: '10px 24px !important'
    },
    '@to576': {
      padding: '8px 8px !important'
      // padding: 0 !important,
    },

    '& .user_dropdown_title': {
      whiteSpace: 'pre-wrap',
      textAlign: 'left'
    },
    '& .user_dropdown_label': {
      textAlign: 'left'
    },
    '& .user_dropdown_item': {
      minHeight: '70px !important'
      // padding: 0 !important;
    }
  },
  '& .user_dropdown': {},
  '& .user_dropdown_item': {
    minHeight: '70px !important'
  },

  '& .user_dropdown_label': {
    display: 'block',
    marginBottom: '-3px',
    fontSize: '16px',

    '@toTable': {
      fontSize: '14px'
    }
  },

  '& .user_dropdown_title': {
    fontSize: '18px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',

    '@toTable': {
      fontSize: '16px'
    }
  }
});

export { DropDown };
